import classNames from 'classnames'
import * as React from 'react'

import * as Assets from '../../assets'
import { TDeviceAttribute } from '../../types'
import * as Utils from '../../utils'
import classes from './index.module.scss'

interface IProps {
    view: 'row' | 'tile' | 'marken'
    sensorData: { value: boolean | number; epoch: number } | undefined
    sensorName: string
    onClick?: (sensorName: string) => void
    active?: boolean
    config?: TDeviceAttribute
    className?: string
}

export const Sensor = ({
    view,
    sensorData,
    sensorName,
    onClick,
    active,
    config,
    className = ''
}: IProps): JSX.Element => {
    const getIconSrc = (m?: string): string => {
        if (!m) {
            return Assets.ImgBroken
        }

        return Utils.sensorIcons.get(m) || Assets.ImgBroken
    }

    const onClickHandler = (event: React.MouseEvent<HTMLElement>): void => {
        event.preventDefault()
        if (onClick && config?.clickable) {
            onClick(sensorName)
        }
    }

    const tileView = (
        <div
            className={classNames(classes.tileView, className, active ? classes.tileView_active : '')}
            onClick={onClickHandler}
        >
            <div className={classes.tileView__column}>
                <div className={classNames(classes.tileView__data, classes.data)}>
                    <div className={classes.data__row}>
                        <img className={classes.data__img} alt={''} src={getIconSrc(config?.icon)} />
                        <div className={classes.data__value}>
                            {Utils.getSensorDisplayValue(sensorData?.value, config)}
                        </div>
                        <div className={classes.data__img} />
                    </div>
                </div>
                <div className={classes.tileView__title}>{config?.displayName}</div>
                <div className={classes.tileView__dateTime}>
                    {sensorData ? Utils.time.format(sensorData.epoch, 'D MMMM YYYY HH:mm:ss') : '--'}
                </div>
            </div>
        </div>
    )

    const rowView = (
        <div className={classNames(classes.rowView, className)}>
            <div className={classes.rowView__row}>
                <img className={classes.rowView__img} alt={''} src={getIconSrc(config?.icon)} />
                <div className={classes.rowView__sensorName}>{config?.displayName}</div>
                <div className={classes.rowView__value}>{Utils.getSensorDisplayValue(sensorData?.value, config)}</div>
            </div>
        </div>
    )

    const markenView = (
        <div
            className={classNames(classes.markenView, className, active ? classes.markenView_active : '')}
            onClick={onClickHandler}
        >
            <div className={classes.markenView__column}>
                <img className={classes.markenView__img} alt={''} src={getIconSrc(config?.icon)} />
                <div className={classes.markenView__value}>
                    {Utils.getSensorDisplayValue(sensorData?.value, config)}
                </div>
                <div className={classes.markenView__title}>{config?.displayName}</div>
                <div className={classes.markenView__dateTime}>
                    {sensorData ? Utils.time.format(sensorData.epoch, 'YYYY-MMM-D HH:mm') : '--'}
                </div>
            </div>
        </div>
    )

    switch (view) {
        case 'tile':
            return tileView
        case 'row':
            return rowView
        case 'marken':
            return markenView
        default:
            return <>View {view} is not support</>
    }
}
